<script>
import { mapState, mapActions } from 'vuex'
import StatisticCard from '@/components/cards/StatisticCard.vue'

export default {
   components: {
      StatisticCard,
   },
   computed: {
      ...mapState({
         myData: state => state.DashboardLkpmNonUmk.statistik,
      }),
      getThisYear() {
         return new Date().getFullYear()
      },
      statisticCards() {
         return [
            {
               group: 'umk',
               key: 'periode_1',
               icon: 'TrendingUpIcon',
               title: `UMK Semester I Tahun ${this.getThisYear}`,
               statistic: this.formatStatistic(this.myData.umk.periode_1),
            },
            {
               group: 'umk',
               key: 'periode_2',
               icon: 'TrendingUpIcon',
               title: `UMK Semester II Tahun ${this.getThisYear}`,
               statistic: this.formatStatistic(this.myData.umk.periode_2),
            },
            {
               group: 'nonumk',
               key: 'periode_1',
               icon: 'BarChart2Icon',
               title: `Non UMK Triwulan I Tahun ${this.getThisYear}`,
               statistic: this.formatStatistic(this.myData.nonumk.periode_1),
            },
            {
               group: 'nonumk',
               key: 'periode_2',
               icon: 'BarChart2Icon',
               title: `Non UMK Triwulan II Tahun ${this.getThisYear}`,
               statistic: this.formatStatistic(this.myData.nonumk.periode_2),
            },
            {
               group: 'nonumk',
               key: 'periode_4',
               icon: 'BarChart2Icon',
               title: `Non UMK Triwulan III Tahun ${this.getThisYear}`,
               statistic: this.formatStatistic(this.myData.nonumk.periode_4),
            },
            {
               group: 'nonumk',
               key: 'periode_5',
               icon: 'BarChart2Icon',
               title: `Non UMK Triwulan IV Tahun ${this.getThisYear}`,
               statistic: this.formatStatistic(this.myData.nonumk.periode_5),
            },
         ]
      },
   },
   mounted() {
      this.getStatistik(this.getThisYear)
   },
   methods: {
      formatStatistic(value) {
         return Number(value || 0).toLocaleString('id-ID')
      },
      ...mapActions({
         getStatistik: 'DashboardLkpmNonUmk/getStatistik',
      }),
   },
}
</script>

<template>
   <b-row>
      <b-col md="12" cols="12">
         <b-card class="oss-color">
            <b-row>
               <b-col md="3">
                  <b-card no-body class="mb-50">
                     <div class="rounded-top text-center oss-logo-color">
                        <b-img
                           :src="require('@/assets/images/logo/oss.png')"
                           alt="oss"
                           height="100"
                           class="img-fluid"
                        />
                     </div>
                     <b-card-body>
                        <b-card-title class="mb-25">
                           LKPM
                        </b-card-title>
                        <b-card-text class="mb-0">
                           <small>Statistik Realisasi Investasi UMK dan Non UMK</small>
                        </b-card-text>
                     </b-card-body>
                  </b-card>
               </b-col>
               <b-col md="9">
                  <b-row>
                     <b-col cols="12" md="6">
                        <statistic-card
                           icon="TrendingUpIcon"
                           :statistic="statisticCards[0].statistic"
                           color="dark"
                           :statistic-title="statisticCards[0].title"
                        />
                        <statistic-card
                           icon="TrendingUpIcon"
                           :statistic="statisticCards[1].statistic"
                           color="dark"
                           :statistic-title="statisticCards[1].title"
                        />
                     </b-col>
                     <b-col cols="12" md="6">
                        <statistic-card
                           icon="BarChart2Icon"
                           :statistic="statisticCards[2].statistic"
                           color="dark"
                           :statistic-title="statisticCards[2].title"
                        />
                        <statistic-card
                           icon="BarChart2Icon"
                           :statistic="statisticCards[3].statistic"
                           color="dark"
                           :statistic-title="statisticCards[3].title"
                        />
                        <statistic-card
                           icon="BarChart2Icon"
                           :statistic="statisticCards[4].statistic"
                           color="dark"
                           :statistic-title="statisticCards[4].title"
                        />
                        <statistic-card
                           icon="BarChart2Icon"
                           :statistic="statisticCards[5].statistic"
                           color="dark"
                           :statistic-title="statisticCards[5].title"
                        />
                     </b-col>
                  </b-row>
               </b-col>
            </b-row>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.oss-color {
   background-color: #8BC6EC;
   background-image: linear-gradient(135deg, #1e9600 0%, #fff200 100%);
}

.oss-logo-color {
   background-color: #ffdee9;
   background-image: linear-gradient(0deg, #ffdee9 0%, #b5fffc 100%);
}
</style>
